import { render } from "./cFooter.vue?vue&type=template&id=25ebf3e2"
import script from "./cFooter.vue?vue&type=script&lang=js"
export * from "./cFooter.vue?vue&type=script&lang=js"

import "./cFooter.vue?vue&type=style&index=0&id=25ebf3e2&lang=css"

import exportComponent from "C:\\DevOps\\Internal\\ClockWork.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__